import React from "react";
import Grid from "@mui/material/Grid";
import logo from "./../../../assets/images/logo.png";
import { Button } from "@mui/material";
import "./navbar.css";
let Navbar = (props) => {
  return (
    <div style={{ backgroundColor: "white" }}>
      <Grid container>
        <Grid item xs={12}>
          <div className="main-appbar-container">
            <div className="main-appbar-content-wraper">
              <Button variant="text">
                <img src={logo} alt="logo" />
              </Button>
              <div>
                <Button
                  variant="text"
                  className="sign-up-btn"
                  onClick={props.HeaderNavigateHandler}
                >
                  {props.title}
                </Button>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Navbar;
